module.exports = __webpack_public_path__ + "img/KPNG_Cover.b238714a.jpg";